var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 6C7.58505 6 6 7.58505 6 9.5V14.5C6 16.415 7.58505 18 9.5 18H17.5C17.795 18 18 18.205 18 18.5V23.0801C17.7036 23.1811 17.4463 23.3723 17.2641 23.627C17.0818 23.8816 16.9839 24.1869 16.9839 24.5C16.9839 24.8131 17.0818 25.1184 17.2641 25.373C17.4463 25.6277 17.7036 25.8189 18 25.9199V28.5C18 35.9378 24.0622 42 31.5 42H38.5C40.415 42 42 40.415 42 38.5V33.5C42 31.585 40.415 30 38.5 30H30.5C30.205 30 30 29.795 30 29.5V25.9199C30.2964 25.8189 30.5537 25.6277 30.7359 25.373C30.9182 25.1184 31.0161 24.8131 31.0161 24.5C31.0161 24.1869 30.9182 23.8816 30.7359 23.627C30.5537 23.3723 30.2964 23.1811 30 23.0801V19.5C30 12.0622 23.9378 6 16.5 6H9.5ZM9.5 9H16.5C22.3162 9 27 13.6838 27 19.5V23H21V18.5C21 16.585 19.415 15 17.5 15H9.5C9.20495 15 9 14.795 9 14.5V9.5C9 9.20495 9.20495 9 9.5 9ZM21 26H27V29.5C27 31.415 28.585 33 30.5 33H38.5C38.795 33 39 33.205 39 33.5V38.5C39 38.795 38.795 39 38.5 39H31.5C25.6838 39 21 34.3162 21 28.5V26Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGi);
export default __webpack_public_path__ + "static/media/gi.f88195cc59d9542a0cf057a0bb3c313f.svg";
export { ForwardRef as ReactComponent };